import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PortChargesTabComponent } from './port-charges-tab/port-charges-tab';
import { CarriersTabComponent } from './carriers-tab/carriers-tab';
import { PortAssignmentsTabComponent } from './port-assignments-tab/port-assignments-tab';

@Component({
  selector: 'app-port-charges-management-modal',
  standalone: true,
  imports: [CommonModule, PortChargesTabComponent, CarriersTabComponent, PortAssignmentsTabComponent],
  templateUrl: './port-charges-management-modal.html',
  styleUrl: './port-charges-management-modal.css'
})
export class PortChargesManagementModalComponent implements OnInit {
  showModal = false;
  activeTab: 'port-charges' | 'carriers' | 'port-assignments' = 'carriers'; // Default to carriers for now

  constructor() {}

  ngOnInit(): void {
    console.log('[PortChargesManagementModal] Component initialized');
  }

  open(): void {
    this.showModal = true;
    console.log('[PortChargesManagementModal] Modal opened');
  }

  close(): void {
    this.showModal = false;
    console.log('[PortChargesManagementModal] Modal closed');
  }

  switchTab(tab: 'port-charges' | 'carriers' | 'port-assignments'): void {
    this.activeTab = tab;
    console.log('[PortChargesManagementModal] Switched to tab:', tab);
  }
}
